import React from 'react';

const NotFound = () => {
    return (
        <div className={"section-not-found"}>
            <h1>404</h1>
        </div>
    );
};

export default NotFound;
